import React from "react";

import { useHeaderMenu } from "../../../hooks/use-header-menu";
import { Icon } from "../../icon";

export function HeaderMenuItemCloseButton() {
  const { setItemPanelExpanded } = useHeaderMenu();
  return (
    <button type="button" onClick={() => setItemPanelExpanded(false)}>
      <Icon icon="close" className="w-10" />
    </button>
  );
}
